/**
 * Inicialización de la clase DeviceInfoModel, modelo de la información del dispositivo donde es cargada la aplicación
 * *Set DeviceInfoModel class, model of the device information where the applicaction is being run*
 *
 * @access public
 * @type {class}
 */
export class DeviceInfoModel {

  /**
   * Identificación del dispositivo donde la aplicación es ejecutada
   *
   * *Device identification where the application is being run*
   *
   * @type {string} device_id
   */
  device_id: string;

  /**
   * Sistema operativo del dispositivo que esa corriendo la aplicación
   *
   * *Operation system of the device where the application is being run*
   *
   * @type {string} os_version
   */
  os_version: string;

  /**
   * Marca del dispositivo que esa corriendo la aplicación
   *
   * *Brand of the device where the application is being run*
   *
   * @type {string} brand
   */
  brand: string;

  /**
   * Modelo del dispositivo que esa corriendo la aplicación
   *
   * *Model of the device where the application is being run*
   *
   * @type {string} model
   */
  model: string;

  /**
   * Constructor de la clase
   * *Class Contstructor.*
   *
   * @var {string}   device_id  Sets variable as empty
   * @var {string}   os_version Sets variable as empty
   * @var {string}   brand      Sets variable as empty
   * @var {string}   model      Sets variable as empty
   *
   */
  constructor() {
    this.device_id = '';
    this.os_version = '';
    this.brand = '';
    this.model = '';
  }
}
